import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from '../layouts/full/shared/loadable/Loadable';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

import ProtectedRoute from './ProtectRoute';

const LoginPage = Loadable(lazy(() => import('../pages/authentication/LoginPage')));
const PropertyPage = Loadable(lazy(() => import('../pages/dashboard/Properties')));
const AccountSetting = Loadable(lazy(() => import('../pages/dashboard/AccountSetting')));
const ForgetPassword = Loadable(lazy(() => import('../pages/authentication/ForgetPassword')));
const ResetPassword = Loadable(lazy(() => import('../pages/authentication/ResetPassword')));
const EnquiryPage = Loadable(lazy(() => import('../pages/dashboard/Enquiry')));
const BookingPage = Loadable(lazy(() => import('../pages/dashboard/BookingPage')));
const DashBoard = Loadable(lazy(() => import('../pages/dashboard/DashBoardPage')));
const BlockCalender = Loadable(lazy(() => import('../pages/dashboard/BlockCalender')));
const PayoutHistory = Loadable(lazy(() => import('../pages/dashboard/PayoutHistory')));
const Bookings = Loadable(lazy(() => import('../pages/dashboard/Bookings')));
const TermsAndContions = Loadable(lazy(() => import('../pages/policy/TermsAndConditions')));
const PrivacyPolicy = Loadable(lazy(() => import('../pages/policy/PrivacyPolicy')));
const HostPolicy = Loadable(lazy(() => import('../pages/policy/HostPolicy')));
const HelpSupport = Loadable(lazy(() => import('../pages/policy/HelpAndSupport')));
const NotificationsPage = Loadable(lazy(() => import('../pages/dashboard/NotificationPage')));
const Router = [
  {
    path: '/dashboards',
    element: <ProtectedRoute isPrivate={true} />,
    children: [
      {
        path: '/dashboards',
        element: <FullLayout />,
        children: [
          { path: '/dashboards/details', element: <DashBoard /> },
          { path: '/dashboards/property-list', element: <PropertyPage /> },
          { path: '/dashboards/account-settings', element: <AccountSetting /> },
          // { path: '/dashboards/enquiries', element: <EnquiryPage /> },
          { path: '/dashboards/booking-list', element: <BookingPage /> },
          { path: '/dashboards/block-calendar', element: <BlockCalender /> },
          { path: '/dashboards/payout-history', element: <PayoutHistory /> },
          { path: '/dashboards/bookings', element: <Bookings /> },

          // { path: '*', element: <Navigate to="/dashboards/home" replace /> },
        ],
      },
    ],
  },
  {
    path: '/policy',
    children: [
      { path: '/policy/terms-and-conditions', element: <TermsAndContions /> },
      { path: '/policy/privacy-policy', element: <PrivacyPolicy /> },
      { path: '/policy/host-policy', element: <HostPolicy /> },
      { path: '/policy/host-help', element: <HelpSupport /> },
    ],
  },
  {
    path: '/notification',
    element: <FullLayout />,
    children: [
      {
        path: '/notification',
        element: <NotificationsPage />
      },
    ],
  },

  {
    path: '/',
    element: <ProtectedRoute isPrivate={false} />,
    children: [
      {
        path: '/',
        element: <BlankLayout />,
        children: [
          { path: '/', element: <Navigate to="/dashboards/home" /> },
          { path: '/auth/login', element: <LoginPage /> },
          { path: '/auth/forget-password', element: <ForgetPassword /> },
          { path: '/auth/reset-password/:token', element: <ResetPassword /> },
          { path: '*', element: <Navigate to="/auth/login" replace /> },
        ],
      },
    ],
  },
];

export default Router;
